// Maps a campaign status to its pill modifier class (styles in CampaignsPage.css).
const STATUS_CLASS = {
  active: 'running',
  running: 'running',
  completed: 'completed',
  scheduled: 'scheduled',
  draft: 'draft',
  paused: 'paused',
  stopped: 'stopped',
  failed: 'failed',
  error: 'failed'
};

export function campaignStatusClass(status) {
  return `cmp-pill cmp-pill--${STATUS_CLASS[status] || 'draft'}`;
}
